<template>
	<div id="crisisEventEscalationDetails">
		<h2>危机事件基本情况上报</h2>
		<div class="describe">
			本表旨在全面深入了解学生发生心理危机的过程性重要信息，以便日后能更精准地防止类似情况的出现。请学校按要求填写。数据信息将同步至云平台的教育局端口。基于数据安全原因，信息一旦提交，则无法删除或修改，<span>请确保信息填写无误后再上报</span>。
		</div>
		<div>
			<div class="title">学生基本信息</div>
			<div class="content">
				<div class="row">
					姓 名：
					<a-input  placeholder="请输入" v-model="REAL_NAME" />
					<span v-if="isShow && !REAL_NAME" class="warning"><a-icon type="info-circle" />请输入学生姓名</span>
				</div>
				<div class="row">
					年级班级：
					<a-select class="option" placeholder="请选择" style="width: 120px" allowClear v-model="GRADE_ID" @change="handleChangeGrade">
						<a-select-option v-for="item in schoolGrades" :key="item" :value="item">{{item}}</a-select-option>
					</a-select>
					<a-input placeholder="请输入" suffix="班" v-model="CLASS_ID" type="number" :min="1" :max="100" />
					<span v-if="isShow && !(GRADE_ID && CLASS_ID)" class="warning"><a-icon type="info-circle" />请选择学生年级班级</span>
				</div>
				<div class="row">
					籍 贯：
					<a-input  placeholder="请输入" v-model="NATIVE_PLACE" />
					<span v-if="isShow && !NATIVE_PLACE" class="warning"><a-icon type="info-circle" />请输入学生籍贯</span>
				</div>
				<div class="row">
					户籍地：
					<a-input  placeholder="请输入" v-model="REGISTE" />
					<span v-if="isShow && !REGISTE" class="warning"><a-icon type="info-circle" />请输入学生户籍地</span>
				</div>
				<div class="row">
					身份证号码：
					<a-input  placeholder="请输入" v-model="STUDENT_ID_CARD" />
					<span v-if="isShow && !STUDENT_ID_CARD" class="warning"><a-icon type="info-circle" />请输入学生身份证号</span>
				</div>
				<div class="column">
					<div>家庭所在地：
						<a-popover placement="top">
							<template slot="content">市-区/县-乡镇/街道</template>
							<a-icon type="question-circle" />
						</a-popover>
					</div>
					<a-input  placeholder="请输入" v-model="ADDRESS" />
					<span v-if="isShow && !ADDRESS" class="warning"><a-icon type="info-circle" />请输入学生家庭所在地</span>
				</div>
			</div>
		</div>
		<div>
			<div class="title">家庭基础信息</div>
			<div class="content">
				<div class="row">
					家庭结构：
					<a-select class="option" placeholder="请选择" style="width: 120px" allowClear v-model="FAMILY_FORM" @change="handleChangeFAMILYFORM">
						<a-select-option v-for="item in FAMILY_FORM_LIST" :key="item" :value="item">{{item}}</a-select-option>
					</a-select>
					<a-input v-if="FAMILY_FORM_INPUT_FLAG" placeholder="选择“其他”，请填空说明" v-model="FAMILY_FORM_INPUT" />
					<span v-if="isShow && !FAMILY_FORM" class="warning"><a-icon type="info-circle" />请选择家庭结构</span>
					<span v-if="isShow && FAMILY_FORM && FAMILY_FORM_INPUT_FLAG && !FAMILY_FORM_INPUT" class="warning"><a-icon type="info-circle" />请填空说明</span>
				</div>
				<div class="row">
					家庭收入水平：
					<a-select class="option" placeholder="请选择" style="width: 120px" allowClear v-model="FAMILY_INCOME" @change="handleChangeFAMILYINCOME">
						<a-select-option v-for="item in FAMILY_INCOME_LIST" :key="item" :value="item">{{item}}</a-select-option>
					</a-select>
					<a-popover placement="top">
						<template slot="content">在当地的收入水平</template>
						<a-icon type="question-circle" />
					</a-popover>
					<span v-if="isShow && !FAMILY_INCOME" class="warning"><a-icon type="info-circle" />请选择家庭收入水平</span>
				</div>
				<div class="row">
					家庭精神病史：
					<a-select class="option" placeholder="请选择" style="width: 120px" allowClear v-model="FAMILY_MEDICAL_HISTORY" @change="handleChangeFAMILYMEDICALHISTORY">
						<a-select-option v-for="item in FAMILY_MEDICAL_HISTORY_LIST" :key="item" :value="item">{{item}}</a-select-option>
					</a-select>
					<a-input v-if="FAMILY_MEDICAL_HISTORY_INPUT_FLAG" placeholder="选择“有”，请填空说明" v-model="FAMILY_MEDICAL_HISTORY_INPUT" />
					<span v-if="isShow && !FAMILY_MEDICAL_HISTORY" class="warning"><a-icon type="info-circle" />请选择家庭精神病史</span>
					<span v-if="isShow && FAMILY_MEDICAL_HISTORY && FAMILY_MEDICAL_HISTORY_INPUT_FLAG && !FAMILY_MEDICAL_HISTORY_INPUT" class="warning"><a-icon type="info-circle" />请填空说明</span>
				</div>
				<div class="row flexStart">
					<b>家庭成员情况：</b>
					<div>
						<a-form :form="form">
							<dynamic-form
								:wrapHeight="360"
								:arr="FAMILY_MEMBERS_INFO"
							/>
						</a-form>
						<p>(职业参考：公务员/事业单位/国企/私企/自由职业/务农/失业/其他)</p>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div class="title">危机发生前的状态</div>
			<div class="content">
				<div class="row">
					<div class="tags">是否已被列入重点关爱学生名单：</div>
					<a-radio-group :options="IS_MAIN_LIST_LIST" v-model="IS_MAIN_LIST" @change="handleChangeISMAIN" />
					<span v-if="isShow && !IS_MAIN_LIST" class="warning"><a-icon type="info-circle" />请选择是否已被列入重点关爱学生名单</span>
				</div>
				<div class="row shrink" v-if="IS_MAIN_LIST === '是'">
					<div class="tags">关爱等级：</div>
					<a-radio-group :options="CARE_LEVEL_LIST" v-model="CARE_LEVEL" @change="handleChangeCARELEVEL" />
					<span v-if="isShow && !CARE_LEVEL" class="warning"><a-icon type="info-circle" />请选择关爱等级</span>
				</div>
				<div class="row shrink" v-if="IS_MAIN_LIST === '是'">
					<div class="tags">学校采取的干预措施（可多选）：</div>
					<div style="display:flex;flex-direction: column;">
						<a-checkbox-group v-model="TAKE_MEASURES" name="checkboxgroup" :options="TAKE_MEASURES_LIST" />
						<a-input v-if="TAKE_MEASURES_INPUT_FLAG" style="margin-top: 6px" placeholder="选择“其他”，请填空说明" v-model="TAKE_MEASURES_INPUT" />
						<span v-if="isShow && !(TAKE_MEASURES && TAKE_MEASURES.length)" class="warning"><a-icon type="info-circle" />请选择学校采取的干预措施</span>
						<span v-if="isShow && TAKE_MEASURES && TAKE_MEASURES_INPUT_FLAG && !TAKE_MEASURES_INPUT" class="warning"><a-icon type="info-circle" />请填空说明</span>
					</div>
				</div>
				<div class="row">
					<div class="tags">有无在本校心理中心/校外心理机构接受过心理咨询：</div>
					<div style="display:flex;flex-direction: column;">
						<a-radio-group :options="ACCEPT_CONSULT_LIST" v-model="ACCEPT_CONSULT" @change="handleChangeACCEPTCONSULT" />
						<a-input v-if="ACCEPT_CONSULT==='校外咨询（请注明求助原因）'" style="margin-top: 6px" placeholder="选择“校外咨询”，请填空说明" v-model="ACCEPT_CONSULT_INPUT" />
						<span v-if="isShow && !ACCEPT_CONSULT" class="warning"><a-icon type="info-circle" />请选择有无在本校心理中心/校外心理机构接受过心理咨询</span>
						<span v-if="isShow && ACCEPT_CONSULT && ACCEPT_CONSULT==='校外咨询（请注明求助原因）' && !ACCEPT_CONSULT_INPUT" class="warning"><a-icon type="info-circle" />请填空说明</span>
					</div>
				</div>
				<div class="row">
					<div class="tags">危机前有无在专业医疗机构接受过医学诊断：</div>
					<div style="display:flex;flex-direction: column;">
						<a-radio-group :options="ACCEPT_DIAGNOSIS_LIST" v-model="ACCEPT_DIAGNOSIS" @change="handleChangeACCEPTDIAGNOSIS" />
						<a-input v-if="ACCEPT_DIAGNOSIS==='去过医疗机构，诊断结果为：'" style="margin-top: 6px" placeholder="请填写诊断结果" v-model="ACCEPT_DIAGNOSIS_INPUT" />
						<span v-if="isShow && !ACCEPT_DIAGNOSIS" class="warning"><a-icon type="info-circle" />请选择有无在本校心理中心/校外心理机构接受过心理咨询</span>
						<span v-if="isShow && ACCEPT_DIAGNOSIS && ACCEPT_DIAGNOSIS==='去过医疗机构，诊断结果为：' && !ACCEPT_DIAGNOSIS_INPUT" class="warning"><a-icon type="info-circle" />请填空说明</span>
					</div>
				</div>
				<div class="row">
					<div class="tags">危机前有无在专业医疗机构接受过药物治疗：</div>
					<a-radio-group :options="ACCEPT_MEDICAL_LIST" v-model="ACCEPT_MEDICAL" @change="handleChangeACCEPTMEDICAL" />
					<span v-if="isShow && !ACCEPT_MEDICAL" class="warning"><a-icon type="info-circle" />请选择危机前有无在专业医疗机构接受过药物治疗</span>
				</div>
				<div class="row shrink" v-if="ACCEPT_MEDICAL === '有'">
					<div class="tags">如有，非正常死亡前是否有自行停药情况：</div>
					<a-radio-group :options="STOP_DRUG_LIST" v-model="STOP_DRUG" @change="handleChangeSTOPDRUG" />
					<span v-if="isShow && !STOP_DRUG" class="warning"><a-icon type="info-circle" />请选择非正常死亡前是否有自行停药情况</span>
				</div>
				<div class="row flexStart">
					<div class="tags">危机前一周内发生的应激事件（可多选）：</div>
					<div style="display:flex;flex-direction: column;width: 100%">
						<a-checkbox-group v-model="STRESS_EVENT" name="checkboxgroup" :options="STRESS_EVENT_LIST" />
						<a-input v-if="STRESS_EVENT_INPUT_FLAG" style="margin-top: 6px" placeholder="选择“其他”，请填空说明" v-model="STRESS_EVENT_INPUT" />
						<span v-if="isShow && !(STRESS_EVENT && STRESS_EVENT.length)" class="warning"><a-icon type="info-circle" />请选择危机前一周内发生的应激事件</span>
						<span v-if="isShow && STRESS_EVENT && STRESS_EVENT_INPUT_FLAG && !STRESS_EVENT_INPUT" class="warning"><a-icon type="info-circle" />请填空说明</span>
					</div>
				</div>
				<div class="row flexStart">
					<div class="tags">危机前出现负面情绪的载体有（可多选）：</div>
					<div style="display:flex;flex-direction: column;">
						<a-checkbox-group v-model="NEGATIVE_CARRIER" name="checkboxgroup" :options="NEGATIVE_CARRIER_LIST" />
						<a-input v-if="NEGATIVE_CARRIER_INPUT_FLAG" style="margin-top: 6px" placeholder="选择“其他”，请填空说明" v-model="NEGATIVE_CARRIER_INPUT" />
						<span v-if="isShow && !(NEGATIVE_CARRIER && NEGATIVE_CARRIER.length)" class="warning"><a-icon type="info-circle" />请选择危机前出现负面情绪的载体</span>
						<span v-if="isShow && NEGATIVE_CARRIER && NEGATIVE_CARRIER_INPUT_FLAG && !NEGATIVE_CARRIER_INPUT" class="warning"><a-icon type="info-circle" />请填空说明</span>
					</div>
				</div>
				<div class="column">
					内容复印件（必填）
					<!-- .doc,.docx, -->
					<div style="margin-top: 10px">
						<a-upload-dragger
							name="file"
							accept=".pdf"
							:file-list="fileList"
							@change="handleChangefiles"
							style="margin-top: 0px;display: block;width: 120px;"
							:beforeUpload="beforeUploadfile"
						>
								<div style="padding: 20px 0px">
									<a-icon type="plus" />
								<div class="ant-upload-text">
									上传文件
								</div>
								</div>
							</a-upload-dragger>
						<span></span>
					</div>
					<span v-if="isShow && !(fileList && fileList.length)" class="warning"><a-icon type="info-circle" />请上传内容复印件</span>
				</div>
			</div>
		</div>
		<div>
			<div class="title">危机发生前对该生的观察</div>
			<div class="content">
				<div class="row">
					<div class="tags">该生看待事物的思维倾向：</div>
					<div style="display:flex;flex-direction: column;">
						<a-radio-group :options="THINK_DIRECTION_LIST" v-model="THINK_DIRECTION" @change="handleChangeTHINKDIRECTION" />
						<span v-if="isShow && !THINK_DIRECTION" class="warning"><a-icon type="info-circle" />请选择该生看待事物的思维倾向</span>
					</div>
				</div>
				<div class="row">
					<div class="tags">该生看待自己的发展目标：</div>
					<div style="display:flex;flex-direction: column;">
						<a-radio-group :options="DEVELOP_TARGET_LIST" v-model="DEVELOP_TARGET" @change="handleChangeDEVELOPTARGET" />
						<span v-if="isShow && !DEVELOP_TARGET" class="warning"><a-icon type="info-circle" />请选择该生看待自己的发展目标</span>
					</div>
				</div>
				<div class="row">
					<div class="tags">该生的情绪管理控制力：</div>
					<div style="display:flex;flex-direction: column;">
						<a-radio-group :options="MANAGE_POWER_LIST" v-model="MANAGE_POWER" @change="handleChangeMANAGEPOWER" />
						<span v-if="isShow && !MANAGE_POWER" class="warning"><a-icon type="info-circle" />请选择该生的情绪管理控制力</span>
					</div>
				</div>
				<div class="row flexStart">
					<div class="tags">该生有无这些性格特点（可多选）：</div>
					<div style="display:flex;flex-direction: column;">
						<a-checkbox-group v-model="CHARACTER_POINT" name="checkboxgroup" :options="CHARACTER_POINT_LIST" />
						<span v-if="isShow && !(CHARACTER_POINT && CHARACTER_POINT.length)" class="warning"><a-icon type="info-circle" />请选择该生的性格特点</span>
					</div>
				</div>
				<div class="row">
					<div class="tags">该生的朋友数量：</div>
					<div style="display:flex;flex-direction: column;">
						<a-radio-group :options="FRIEND_NUM_LIST" v-model="FRIEND_NUM" @change="handleChangeFRIENDNUM" />
						<span v-if="isShow && !FRIEND_NUM" class="warning"><a-icon type="info-circle" />请选择该生的朋友数量</span>
					</div>
				</div>
				<div class="row flexStart">
					<div class="tags">该生的睡眠情况：</div>
					<div style="display:flex;flex-direction: column;">
						<a-radio-group :options="SLEEP_SITUATION_LIST" v-model="SLEEP_SITUATION" @change="handleChangeSLEEPSITUATION" />
						<span v-if="isShow && !SLEEP_SITUATION" class="warning"><a-icon type="info-circle" />请选择该生的睡眠情况</span>
					</div>
				</div>
				<div class="row flexStart">
					<div class="tags">该生的亲子关系（可多选）：</div>
					<div style="display:flex;flex-direction: column;">
						<a-checkbox-group v-model="PARENT_CHILD_RELATIONSHIP" name="checkboxgroup" :options="PARENT_CHILD_RELATIONSHIP_LIST" />
						<span v-if="isShow && !(PARENT_CHILD_RELATIONSHIP && PARENT_CHILD_RELATIONSHIP.length)" class="warning"><a-icon type="info-circle" />请选择该生的亲子关系</span>
					</div>
				</div>
				<div class="row">
					<div class="tags">该生的学业水平：</div>
					<div style="display:flex;flex-direction: column;">
						<a-radio-group :options="ACADEMIC_LEVEL_LIST" v-model="ACADEMIC_LEVEL" @change="handleChangeACADEMICLEVEL" />
						<span v-if="isShow && !ACADEMIC_LEVEL" class="warning"><a-icon type="info-circle" />请选择该生的学业水平</span>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div class="title">危机发生时的情况</div>
			<div class="content">
				<div class="row">
					<div class="tags">危机发生时是否处于休学或停学状态：</div>
					<div style="display:flex;flex-direction: column;">
						<a-radio-group :options="IS_SCHOOL_STATUS_LIST" v-model="IS_SCHOOL_STATUS" @change="handleChangeISSCHOOLSTATUS" />
						<a-input v-if="IS_SCHOOL_STATUS==='是'" style="margin-top: 6px" placeholder="请写明离校的时长" v-model="IS_SCHOOL_STATUS_INPUT" />
						<span v-if="isShow && !IS_SCHOOL_STATUS" class="warning"><a-icon type="info-circle" />请选择危机发生时是否处于休学或停学状态</span>
						<span v-if="isShow && IS_SCHOOL_STATUS && IS_SCHOOL_STATUS==='是' && !IS_SCHOOL_STATUS_INPUT" class="warning"><a-icon type="info-circle" />请填空说明</span>
					</div>
				</div>
				<div class="row">
					<div class="tags">危机发生时间：</div>
					<a-date-picker @change="handleChangeCRISISTIMEONE" :value="CRISIS_TIME_ONE === undefined ? CRISIS_TIME_ONE : moment(CRISIS_TIME_ONE, 'YYYY-MM-DD')" placeholder="请选择日期" />
					<a-time-picker style="margin-left: 8px" @change="handleChangeCRISISTIMETWO" :value="CRISIS_TIME_TWO === undefined ? CRISIS_TIME_TWO : moment(CRISIS_TIME_TWO, 'HH:mm:ss')" placeholder="请选择时间" />
					<span v-if="isShow && !(CRISIS_TIME_ONE && CRISIS_TIME_TWO)" class="warning"><a-icon type="info-circle" />请选择危机发生时间</span>
				</div>
				<div class="row">
					<div class="tags">危机发生地点：</div>
					<div style="display:flex;flex-direction: column;">
						<a-radio-group :options="CRISIS_ADDRESS_LIST" v-model="CRISIS_ADDRESS" @change="handleChangeCRISISADDRESS" />
						<a-input v-if="CRISIS_ADDRESS" style="margin-top: 6px" :placeholder="'请写明' + CRISIS_ADDRESS + '具体地点'" v-model="CRISIS_ADDRESS_INPUT" />
						<span v-if="isShow && !CRISIS_ADDRESS" class="warning"><a-icon type="info-circle" />请选择危机发生地点</span>
						<span v-if="isShow && CRISIS_ADDRESS && !CRISIS_ADDRESS_INPUT" class="warning"><a-icon type="info-circle" />请填空说明</span>
					</div>
				</div>
				<div class="row">
					<div class="tags">危机发生方式：</div>
					<div style="display:flex;flex-direction: column;">
						<a-radio-group :options="CRISIS_WAY_LIST" v-model="CRISIS_WAY" @change="handleChangeCRISISWAY" />
						<a-input v-if="CRISIS_WAY==='其他'" style="margin-top: 6px" placeholder="选择“其他”，请填空说明" v-model="CRISIS_WAY_INPUT" />
						<span v-if="isShow && !CRISIS_WAY" class="warning"><a-icon type="info-circle" />请选择危机发生方式</span>
						<span v-if="isShow && CRISIS_WAY && CRISIS_WAY==='其他' && !CRISIS_WAY_INPUT" class="warning"><a-icon type="info-circle" />请填空说明</span>
					</div>
				</div>
				<div class="row flexStart">
					<div class="tags">危机发生的主要原因：</div>
					<div style="display:flex;flex-direction: column;">
						<a-checkbox-group v-model="CRISIS_REASON" name="checkboxgroup" :options="CRISIS_REASON_LIST" />
						<a-input v-if="CRISIS_REASON_INPUT_FLAG" style="margin-top: 6px" placeholder="选择“其他”，请填空说明" v-model="CRISIS_REASON_INPUT" />
						<span v-if="isShow && !(CRISIS_REASON && CRISIS_REASON.length)" class="warning"><a-icon type="info-circle" />请选择危机发生的主要原因</span>
						<span v-if="isShow && CRISIS_REASON && CRISIS_REASON_INPUT_FLAG && !CRISIS_REASON_INPUT" class="warning"><a-icon type="info-circle" />请填空说明</span>
					</div>
				</div>
				<div class="column">
					<div class="tags">对危机过程的补充描述</div>
					<a-textarea placeholder="请填写补充描述" :rows="4" v-model="CRISIS_SUPPLY" />
					<span v-if="isShow && !CRISIS_SUPPLY" class="warning"><a-icon type="info-circle" />请对危机过程的补充描述</span>
				</div>
				<div class="column">
					内容复印件（非必填）
					<!-- .doc,.docx, -->
					<div style="margin-top: 10px">
						<a-upload-dragger
							name="file"
							accept=".pdf"
							:file-list="fileListOther"
							@change="handleChangefilesOther"
							style="margin-top: 0px;display: block;width: 120px;"
							:beforeUpload="beforeUploadfileOther"
						>
								<div style="padding: 20px 0px">
									<a-icon type="plus" />
								<div class="ant-upload-text">
									上传文件
								</div>
								</div>
							</a-upload-dragger>
						<span></span>
					</div>
				</div>
				<div class="row flexStart">
					<div class="tags">该生目前状态（可多选）：</div>
					<div style="display:flex;flex-direction: column;">
						<a-checkbox-group v-model="CURRENTLY_STATUS" name="checkboxgroup" :options="CURRENTLY_STATUS_LIST" />
						<a-input v-if="CURRENTLY_STATUS_INPUT_FLAG" style="margin-top: 6px" placeholder="选择“其他”，请填空说明" v-model="CURRENTLY_STATUS_INPUT" />
						<span v-if="isShow && !(CURRENTLY_STATUS && CURRENTLY_STATUS.length)" class="warning"><a-icon type="info-circle" />请选择该生目前状态</span>
						<span v-if="isShow && CURRENTLY_STATUS && CURRENTLY_STATUS_INPUT_FLAG && !CURRENTLY_STATUS_INPUT" class="warning"><a-icon type="info-circle" />请填空说明</span>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div class="title">学校联系人</div>
			<div class="content">
				<div class="column">
					联络人姓名
					<a-input  placeholder="请输入" v-model="CONTACT_NAME" />
					<span v-if="isShow && !CONTACT_NAME" class="warning"><a-icon type="info-circle" />请输入联络人姓名</span>
				</div>
				<div class="column">
					联系电话
					<a-input  placeholder="请输入" v-model="CONTACT_PHONE" />
					<span v-if="isShow && !CONTACT_PHONE" class="warning"><a-icon type="info-circle" />请输入联系电话</span>
				</div>
				<div class="column">
					邮箱地址
					<a-input  placeholder="请输入" v-model="CONTACT_EMAIL" />
					<span v-if="isShow && !CONTACT_EMAIL" class="warning"><a-icon type="info-circle" />请输入邮箱地址</span>
				</div>
			</div>
			<div class="endof">
				<a-button type="primary" class="trebtn" @click="saveHandle">保存</a-button>
				<a-button type="primary" class="trebtn" @click="cancelHandle">取消</a-button>
				<a-popconfirm
					title="一旦提交，无法修改。"
					ok-text="确定"
					cancel-text="取消"
					@confirm="confirm"
					@cancel="cancel"
				>
					<a-button type="primary">提交</a-button>
				</a-popconfirm>
			</div>
		</div>
	</div>
</template>

<script>
const OSS = require('ali-oss')
import {mapActions, mapMutations, mapState} from 'vuex'
import moment from 'moment';
import DynamicForm from './DynamicForm'
import GRADE from '@/util/grade'
import GRADEYEAR from '@/util/gradeYear'
export default {
	name: 'CrisisEventEscalationDetails',
	data () {
		return {
			// 学生基本信息
			isShow: false,
			REAL_NAME: null, // 姓名
			GRADE_ID: undefined, // 年级
			CLASS_ID: null, // 班级
			NATIVE_PLACE: null, // 籍贯
			REGISTE: null, // 户籍地
			STUDENT_ID_CARD: null, // 身份证
			ADDRESS: null, // 家庭所在地
			// 家庭基础信息
			FAMILY_FORM: undefined, // 家庭结构
			FAMILY_FORM_INPUT_FLAG: false, // 家庭结构--填空--开关
			FAMILY_FORM_INPUT: '', // 家庭结构--填空
			FAMILY_FORM_LIST: ['父母双全', '单亲', '重组', '领养', '留守', '寄养', '其他'], // 家庭结构--列表
			FAMILY_INCOME: undefined, // 家庭收入水平
			FAMILY_INCOME_LIST: ['富裕', '中等偏上', '中等偏下', '贫穷'], // 家庭收入水平--列表
			FAMILY_MEDICAL_HISTORY: undefined, // 家庭精神病史
			FAMILY_MEDICAL_HISTORY_INPUT_FLAG: false, // 家庭精神病史--填空--开关
			FAMILY_MEDICAL_HISTORY_INPUT: '', // 家庭精神病史--填空
			FAMILY_MEDICAL_HISTORY_LIST: ['无', '不明', '有（何人何病）'], // 家庭精神病史--列表
			form: this.$form.createForm(this), // 家庭成员情况表单
      FAMILY_MEMBERS_INFO: [ // 家庭成员情况默认值
        { name: '', work: null }
      ],
			// 危机发生前的状态
			IS_MAIN_LIST: null, // 列入重点关爱学生名单
			IS_MAIN_LIST_LIST: ['否', '是'], // 列入重点关爱学生名单--列表
			CARE_LEVEL: null, // 关爱等级
			CARE_LEVEL_LIST: ['校级关注', '班级关注'], // 关爱等级--列表
			TAKE_MEASURES: null, // 学校采取的干预措施
			TAKE_MEASURES_LIST: ['班主任谈话', '心理教师访谈', '朋辈支持', '危机干预', '联系家长', '建议转介至心理咨询或治疗机构', '其他'], // 学校采取的干预措施--列表
			TAKE_MEASURES_INPUT: '',  // 学校采取的干预措施--填空
			ACCEPT_CONSULT: null, // 接受过心理咨询
			ACCEPT_CONSULT_LIST: ['无', '不明', '校内咨询', '校外咨询（请注明求助原因）'], // 接受过心理咨询--列表
			ACCEPT_CONSULT_INPUT: '', // 接受过心理咨询--填空
			ACCEPT_DIAGNOSIS: null, // 接受过医学诊断
			ACCEPT_DIAGNOSIS_LIST: ['无', '不明', '去过医疗机构，诊断结果为：'], // 接受过医学诊断--列表
			ACCEPT_DIAGNOSIS_INPUT: '', // 接受过医学诊断--填空
			ACCEPT_MEDICAL: null, // 接受过药物治疗
			ACCEPT_MEDICAL_LIST: ['无', '不明', '有'], // 接受过药物治疗--列表
			STOP_DRUG: null, // 有自行停药情况
			STOP_DRUG_LIST: ['无', '不明', '有'], // 有自行停药情况--列表
			STRESS_EVENT: null, // 发生的应激事件
			STRESS_EVENT_LIST: ['学业困难或挂科', '升学困难/留级', '校园封控', '身体缺陷或患重大疾病', '失恋或情感受挫', '严重家庭冲突', '师生关系紧张', '同学关系紧张或冲突', '重要他人重病或去世', '家庭经济困难', '遭受羞辱或批评惩罚', '遭遇性侵或骚扰', '其他'], // 发生的应激事件--列表
			STRESS_EVENT_INPUT: '', // 发生的应激事件--填空
			NEGATIVE_CARRIER: null, // 出现负面情绪的载体
			NEGATIVE_CARRIER_LIST: ['作文/周记', '日记', '与同学/朋友的交谈', 'QQ空间或微信、微博留言', '其他'], // 出现负面情绪的载体--列表
			NEGATIVE_CARRIER_INPUT: '', // 出现负面情绪的载体--填空
			fileList: [], // 第一个上传文件
			// 危机发生前对该生的观察
			THINK_DIRECTION: null, // 思维倾向
			THINK_DIRECTION_LIST: ['积极倾向', '消极倾向', '中间倾向'], // 思维倾向--列表
			DEVELOP_TARGET: null, // 发展目标
			DEVELOP_TARGET_LIST: ['有且坚定清晰', '有但不坚定', '有但不清晰', '无目标'], // 发展目标--列表
			MANAGE_POWER: null, // 情绪管理控制力
			MANAGE_POWER_LIST: ['非常强', '比较强', '一般强', '比较弱', '非常弱'], // 情绪管理控制力--列表
			CHARACTER_POINT: null, // 性格特点
			CHARACTER_POINT_LIST: ['内向', '敏感', '固执', '孤僻', '情绪冲动', '行为冲动', '高自我期待', '高自我批评', '追求完美', '其他'], // 性格特点--列表
			FRIEND_NUM: null, // 朋友数量
			FRIEND_NUM_LIST: ['大于等于5个', '3或4个', '小于等于2个', '没有'], // 朋友数量--列表
			SLEEP_SITUATION: null, // 睡眠情况
			SLEEP_SITUATION_LIST: ['长期失眠，疲惫感强', '经常缺觉，有疲惫感', '偶尔缺觉，疲惫感不强', '睡眠充足，精神振奋'], // 睡眠情况--列表
			PARENT_CHILD_RELATIONSHIP: null, // 亲子关系
			PARENT_CHILD_RELATIONSHIP_LIST: ['与双亲亲密', '与母亲亲密', '与父亲亲密', '与双亲都不亲密', '与母亲对立', '与父亲对立', '与双亲都对立', '没有双亲'], // 亲子关系
			ACADEMIC_LEVEL: null, // 学业水平
			ACADEMIC_LEVEL_LIST: ['冒尖', '中等偏上', '中等', '中等偏下', '倒数'], // 学业水平
			// 危机发生时的情况
			IS_SCHOOL_STATUS: null, // 危机发生时是否处于休学或停学状态
			IS_SCHOOL_STATUS_LIST: ['否', '是'], // 危机发生时是否处于休学或停学状态--列表
			IS_SCHOOL_STATUS_INPUT: null, // 危机发生时是否处于休学或停学状态--填空
			CRISIS_TIME_ONE: undefined, // 日期
			CRISIS_TIME_TWO: undefined, // 时间
			CRISIS_ADDRESS: null, // 危机发生地点
			CRISIS_ADDRESS_LIST: ['校内', '校外'], // 危机发生地点--列表
			CRISIS_ADDRESS_INPUT: '', // 危机发生地点--填空
			CRISIS_WAY: null, // 危机发生方式
			CRISIS_WAY_LIST: ['高坠 ', '自缢', '自溺', '其他'], // 危机发生方式--列表
			CRISIS_WAY_INPUT: '', // 危机发生方式--填空
			CRISIS_REASON: null, // 危机发生的主要原因
			CRISIS_REASON_LIST: ['家庭矛盾', '身体疾病', '师生冲突', '学业困难', '社会矛盾', '其他'], // 危机发生的主要原因--列表
			CRISIS_REASON_INPUT: '', // 危机发生的主要原因--填空
			CRISIS_SUPPLY: null, // 对危机过程的补充描述
			fileListOther: [], // 第二个上传文件
			CURRENTLY_STATUS: null, // 该生目前状态
			CURRENTLY_STATUS_LIST: ['死亡', '昏迷', '重伤', '轻伤', '自行终止行为', '教职工救助成功', '在家休养', '外出就医', '继续就读', '转学', '其他'], // 该生目前状态--列表
			CURRENTLY_STATUS_INPUT: '', // 该生目前状态--填空
			// 学校联系人
			CONTACT_NAME: null, // 联络人
			CONTACT_PHONE: null, // 联系电话
			CONTACT_EMAIL: null, // 邮箱地址
			// 其他字段
			docs: null, // 存放必填文件上传至OSS后生成的URL
			docsOne: null, // 存放选填文件上传至OSS后生成的URL
			UID: null
		}
	},
	computed: {
		...mapState([
			'schoolGrades',
			'schoolInfos',
			'uploadFile',
			'crisisReferSaveInfo'
		]),
		TAKE_MEASURES_INPUT_FLAG () { // 学校采取的干预措施--填空--开关
			if (this.TAKE_MEASURES) {
				if (this.TAKE_MEASURES.includes('其他')) {
					return true
				} else {
					return false
				}
			}
			return false
		},
		STRESS_EVENT_INPUT_FLAG () { // 发生的应激事件--填空--开关
			if (this.STRESS_EVENT) {
				if (this.STRESS_EVENT.includes('其他')) {
					return true
				} else {
					return false
				}
			}
			return false
		},
		NEGATIVE_CARRIER_INPUT_FLAG () {
			if (this.NEGATIVE_CARRIER) {
				if (this.NEGATIVE_CARRIER.includes('其他')) {
					return true
				} else {
					return false
				}
			}
			return false
		},
		CRISIS_REASON_INPUT_FLAG () {
			if (this.CRISIS_REASON) {
				if (this.CRISIS_REASON.includes('其他')) {
					return true
				} else {
					return false
				}
			}
			return false
		},
		CURRENTLY_STATUS_INPUT_FLAG () {
			if (this.CURRENTLY_STATUS) {
				if (this.CURRENTLY_STATUS.includes('其他')) {
					return true
				} else {
					return false
				}
			}
			return false
		}
	},
	components: { DynamicForm },
	methods: {
		...mapMutations([
			'setSpinning'
		]),
		...mapActions([
			'getSchoolInfos',
			'getUploadFile',
			'crisisRefer'
		]),
		moment,
		// 提交数据
		async submitData (type, familyMember, tags) { // type：保存1；提交2   familyMember:家庭成员信息
			console.log(type, '是保存还是提交')
			// 上报信息手机
			let finishData = {}
			// 学生基本信息
			finishData.REAL_NAME = this.REAL_NAME ? this.REAL_NAME : null
			finishData.GRADE_ID = this.GRADE_ID ? GRADE.gradeId(this.GRADE_ID) : null
			finishData.CLASS_ID = this.CLASS_ID ? this.CLASS_ID : null
			finishData.NATIVE_PLACE = this.NATIVE_PLACE ? this.NATIVE_PLACE : null
			finishData.REGISTE = this.REGISTE ? this.REGISTE : null
			finishData.STUDENT_ID_CARD = this.STUDENT_ID_CARD ? this.STUDENT_ID_CARD : null
			finishData.ADDRESS = this.ADDRESS ? this.ADDRESS : null
			// 家庭基础信息
			finishData.FAMILY_FORM = this.FAMILY_FORM ? (this.FAMILY_FORM_INPUT_FLAG ? this.FAMILY_FORM + '&&&' + this.FAMILY_FORM_INPUT : this.FAMILY_FORM) : null
			finishData.FAMILY_INCOME = this.FAMILY_INCOME ? this.FAMILY_INCOME : null
			finishData.FAMILY_MEDICAL_HISTORY = this.FAMILY_MEDICAL_HISTORY ? (this.FAMILY_MEDICAL_HISTORY_INPUT_FLAG ? this.FAMILY_MEDICAL_HISTORY + '&&&' + this.FAMILY_MEDICAL_HISTORY_INPUT : this.FAMILY_MEDICAL_HISTORY) : null
			finishData.FAMILY_MEMBERS_INFO = familyMember ? JSON.stringify(familyMember) : null
			// 危机发生前的状态
			finishData.IS_MAIN_LIST = this.IS_MAIN_LIST ? this.IS_MAIN_LIST : null
			finishData.CARE_LEVEL = (this.IS_MAIN_LIST === '是' && this.CARE_LEVEL) ? this.CARE_LEVEL : null
			finishData.TAKE_MEASURES = (this.IS_MAIN_LIST === '是' && this.TAKE_MEASURES && this.TAKE_MEASURES.length) ? (this.TAKE_MEASURES.includes('其他') ? this.organizeData(this.TAKE_MEASURES, this.TAKE_MEASURES_INPUT) : this.TAKE_MEASURES.join(',')) : null
			finishData.ACCEPT_CONSULT = this.ACCEPT_CONSULT ? (this.ACCEPT_CONSULT === '校外咨询（请注明求助原因）' ? this.ACCEPT_CONSULT + '&&&' + this.ACCEPT_CONSULT_INPUT : this.ACCEPT_CONSULT) : null
			finishData.ACCEPT_DIAGNOSIS = this.ACCEPT_DIAGNOSIS ? (this.ACCEPT_DIAGNOSIS === '去过医疗机构，诊断结果为：' ? this.ACCEPT_DIAGNOSIS + '&&&' + this.ACCEPT_DIAGNOSIS_INPUT : this.ACCEPT_DIAGNOSIS) : null
			finishData.ACCEPT_MEDICAL = this.ACCEPT_MEDICAL ? this.ACCEPT_MEDICAL : null
			finishData.STOP_DRUG = (this.ACCEPT_MEDICAL === '有' && this.STOP_DRUG) ? this.STOP_DRUG : null
			finishData.STRESS_EVENT = (this.STRESS_EVENT && this.STRESS_EVENT.length) ? (this.STRESS_EVENT.includes('其他') ? this.organizeData(this.STRESS_EVENT, this.STRESS_EVENT_INPUT) : this.STRESS_EVENT.join(',')) : null
			finishData.NEGATIVE_CARRIER = (this.NEGATIVE_CARRIER && this.NEGATIVE_CARRIER.length) ? (this.NEGATIVE_CARRIER.includes('其他') ? this.organizeData(this.NEGATIVE_CARRIER, this.NEGATIVE_CARRIER_INPUT) : this.NEGATIVE_CARRIER.join(',')) : null
			finishData.DOCS = this.docs ? JSON.stringify(this.docs) : null
			// 危机发生前对该生的观察
			finishData.THINK_DIRECTION = this.THINK_DIRECTION ? this.THINK_DIRECTION : null
			finishData.DEVELOP_TARGET = this.DEVELOP_TARGET ? this.DEVELOP_TARGET : null
			finishData.MANAGE_POWER = this.MANAGE_POWER ? this.MANAGE_POWER : null
			finishData.CHARACTER_POINT = this.CHARACTER_POINT && this.CHARACTER_POINT.length ? this.CHARACTER_POINT.join(',') : null
			finishData.FRIEND_NUM = this.FRIEND_NUM ? this.FRIEND_NUM : null
			finishData.SLEEP_SITUATION = this.SLEEP_SITUATION ? this.SLEEP_SITUATION : null
			finishData.PARENT_CHILD_RELATIONSHIP = this.PARENT_CHILD_RELATIONSHIP && this.PARENT_CHILD_RELATIONSHIP.length ? this.PARENT_CHILD_RELATIONSHIP.join(',') : null
			finishData.ACADEMIC_LEVEL = this.ACADEMIC_LEVEL ? this.ACADEMIC_LEVEL : null
			// 危机发生时的情况
			finishData.IS_SCHOOL_STATUS = this.IS_SCHOOL_STATUS ? (this.IS_SCHOOL_STATUS === '是' ? this.IS_SCHOOL_STATUS + '&&&' + this.IS_SCHOOL_STATUS_INPUT : this.IS_SCHOOL_STATUS) : null
			finishData.CRISIS_TIME = (this.CRISIS_TIME_ONE || this.CRISIS_TIME_TWO) ? this.CRISIS_TIME_ONE + '&&&' + this.CRISIS_TIME_TWO : null
			finishData.CRISIS_ADDRESS = this.CRISIS_ADDRESS ? this.CRISIS_ADDRESS + '&&&' + this.CRISIS_ADDRESS_INPUT : null
			finishData.CRISIS_WAY = this.CRISIS_WAY ? (this.CRISIS_WAY === '其他' ? this.CRISIS_WAY + '&&&' + this.CRISIS_WAY_INPUT : this.CRISIS_WAY) : null
			finishData.CRISIS_REASON = (this.CRISIS_REASON && this.CRISIS_REASON.length) ? (this.CRISIS_REASON.includes('其他') ? this.organizeData(this.CRISIS_REASON, this.CRISIS_REASON_INPUT) : this.CRISIS_REASON.join(',')) : null
			finishData.CRISIS_SUPPLY = this.CRISIS_SUPPLY ? this.CRISIS_SUPPLY : null
			finishData.CRISIS_DOCS = this.docsOne ? JSON.stringify(this.docsOne) : null
			finishData.CURRENTLY_STATUS = (this.CURRENTLY_STATUS && this.CURRENTLY_STATUS.length) ? (this.CURRENTLY_STATUS.includes('其他') ? this.organizeData(this.CURRENTLY_STATUS, this.CURRENTLY_STATUS_INPUT) : this.CURRENTLY_STATUS.join(',')) : null
			// 学校联系人
			finishData.CONTACT_NAME = this.CONTACT_NAME ? this.CONTACT_NAME : null
			finishData.CONTACT_PHONE = this.CONTACT_PHONE ? this.CONTACT_PHONE : null
			finishData.CONTACT_EMAIL = this.CONTACT_EMAIL ? this.CONTACT_EMAIL : null
			// 其他参数
			finishData.UID = this.UID ? this.UID : null
			console.log(this.UID,"UUUUUUUU")
			finishData.EVENT_NUMBER = this.UID ? (moment().format('YYYYMMDDHHmmss') + '' + this.UID) : null
			let submitResult = await this.crisisRefer({type: type, info: finishData})
			if (submitResult) {
				this.$message.success(`${tags}成功！`)
				this.$router.push('/dataCenter/crisisEventEscalationRecord')
			} else {
				this.$message.error(`${tags}失败，请稍后再试!`)
			}
			this.setSpinning(false)
		},
		messageFun () { // 弹框提示
			this.setSpinning(false)
			this.$message.error('请检查是否有漏填项目!')
			return false
		},
		organizeData (arr, otherValue) { // 多选题选了其他的，把填空和其他拼起来
			let newArr = []
			arr.map(item => {
				// 没有填空的时候到底要不要传null
				(item === '其他' && otherValue) ? newArr.push(item + '&&&' + otherValue) : newArr.push(item)
			})
			return newArr.join(',')
		},
		// 按钮
		async confirm () { // 提交里面的确定
			this.setSpinning(true)
			this.isShow = true
			let familyMember = null
			const { form: { validateFields } } = this
      validateFields((errors, values) => {
				console.log(23)
        if (!errors) {
					familyMember = []
					values.name.map((item, index) => {
						familyMember.push({
							name: item,
							work: values.work[index]
						})
					})
        }
      })
			if (this.REAL_NAME && this.GRADE_ID && this.CLASS_ID && this.NATIVE_PLACE && this.REGISTE && this.STUDENT_ID_CARD && this.ADDRESS
			&& this.FAMILY_FORM && this.FAMILY_INCOME && this.FAMILY_MEDICAL_HISTORY && familyMember
			&& this.IS_MAIN_LIST && this.ACCEPT_CONSULT && this.ACCEPT_DIAGNOSIS && this.ACCEPT_MEDICAL && (this.STRESS_EVENT && this.STRESS_EVENT.length) && (this.NEGATIVE_CARRIER && this.NEGATIVE_CARRIER.length) && (this.fileList && this.fileList.length)
			&& this.THINK_DIRECTION && this.DEVELOP_TARGET && this.MANAGE_POWER && (this.CHARACTER_POINT && this.CHARACTER_POINT.length) && this.FRIEND_NUM && this.SLEEP_SITUATION && (this.PARENT_CHILD_RELATIONSHIP && this.PARENT_CHILD_RELATIONSHIP.length) && this.ACADEMIC_LEVEL
			&& this.IS_SCHOOL_STATUS && this.CRISIS_TIME_ONE && this.CRISIS_TIME_TWO && this.CRISIS_ADDRESS && this.CRISIS_ADDRESS_INPUT && this.CRISIS_WAY && (this.CRISIS_REASON && this.CRISIS_REASON.length) && this.CRISIS_SUPPLY && this.CURRENTLY_STATUS
			&& this.CONTACT_NAME && this.CONTACT_PHONE && this.CONTACT_EMAIL) {
				// 漏填项
				if (this.FAMILY_FORM_INPUT_FLAG && !this.FAMILY_FORM_INPUT) return this.messageFun()
				if (this.FAMILY_MEDICAL_HISTORY_INPUT_FLAG && !this.FAMILY_MEDICAL_HISTORY_INPUT) return this.messageFun()
				if (this.IS_MAIN_LIST === '是' && !(this.CARE_LEVEL && (this.TAKE_MEASURES && this.TAKE_MEASURES.length))) return this.messageFun()
				if (this.IS_MAIN_LIST === '是' && this.TAKE_MEASURES.includes('其他') && !this.TAKE_MEASURES_INPUT) return this.messageFun()
				if (this.ACCEPT_CONSULT === '校外咨询（请注明求助原因）' && !this.ACCEPT_CONSULT_INPUT) return this.messageFun()
				if (this.ACCEPT_DIAGNOSIS === '去过医疗机构，诊断结果为：' && !this.ACCEPT_DIAGNOSIS_INPUT) return this.messageFun()
				if (this.ACCEPT_MEDICAL === '有' && !this.STOP_DRUG) return this.messageFun()
				if (this.STRESS_EVENT.includes('其他') && !this.STRESS_EVENT_INPUT) return this.messageFun()
				if (this.NEGATIVE_CARRIER.includes('其他') && !this.NEGATIVE_CARRIER_INPUT) return this.messageFun()
				if (this.IS_SCHOOL_STATUS === '是' && !this.IS_SCHOOL_STATUS_INPUT) return this.messageFun()
				if (this.CRISIS_WAY === '其他' && !this.CRISIS_WAY_INPUT) return this.messageFun()
				if (this.CRISIS_REASON.includes('其他') && !this.CRISIS_REASON_INPUT) return this.messageFun()
				if (this.CURRENTLY_STATUS.includes('其他') && !this.CURRENTLY_STATUS_INPUT) return this.messageFun()
				// 手机号验证
				let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
				if (myreg.test(this.CONTACT_PHONE)) {
					// 学生姓名和身份证号验证
					let obj = {}
					obj['hide'] = true
					obj['skip'] = 0
					obj['ENTRYYEAR'] = GRADEYEAR(this.GRADE_ID)
					obj['CLASS_ID'] = this.CLASS_ID
					obj['SEARCH'] = this.REAL_NAME
					await this.getSchoolInfos(obj)
					if (this.schoolInfos && this.schoolInfos.length) {
						if (this.schoolInfos[0].STUDENT_ID_CARD === this.STUDENT_ID_CARD) {
							this.UID = this.schoolInfos[0].UID
							// 上传文件-获取临时凭证
							await this.getUploadFile()
							if (this.uploadFile) {
								const client = new OSS({
									// yourRegion填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
									region: 'oss-cn-beijing',
									secure: true,
									// 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
									accessKeyId: this.uploadFile.AccessKeyId,
									accessKeySecret: this.uploadFile.AccessKeySecret,
									// 从STS服务获取的安全令牌（SecurityToken）。
									stsToken: this.uploadFile.SecurityToken,
									// 填写Bucket名称。
									bucket: 'xsjzsite',
									// 刷新临时访问凭证
									refreshSTSToken: async () => {      
										await this.getUploadImg()
										return {
											accessKeyId: this.uploadFile.AccessKeyId,
											accessKeySecret: this.uploadFile.AccessKeySecret,
											stsToken: this.uploadFile.SecurityToken
										}
									}
								})
								this.docs = []
								this.docsOne = []
								console.log(this.fileList, '第一个必选')
								for (const item of this.fileList) {
									let data = item.originFileObj
									const result = await client.put(
										"crisisevents/before/" + (Math.random()*10000000).toString(16).substr(0,6) + new Date().getTime() + '-' + item.name,
										data
									)
									this.docs.push(result.url)
								}
								console.log(this.fileListOther, '第二个选填')
								if (this.fileListOther && this.fileListOther.length) {
									for (const item of this.fileListOther) {
										let data = item.originFileObj
										const result = await client.put(
											"crisisevents/after/" + (Math.random()*10000000).toString(16).substr(0,6) + new Date().getTime() + '-' + item.name,
											data
										)
										this.docsOne.push(result.url)
									}
								}
								this.submitData(2, familyMember, '提交')
							} else {
								this.setSpinning(false)
								this.$message.error('上传文件失败，请稍后再试~')
							}
						} else {
							this.setSpinning(false)
							this.$message.error('请核对学生的身份证号是否和学生列表中一致~')
						}
					} else {
						this.setSpinning(false)
						this.$message.error('没有在学生列表中找到该学生，请核对学生信息~')
					}
				} else {
					this.setSpinning(false)
					this.$message.error('请核对手机号是否有误~')
				}
			} else {
				this.setSpinning(false)
				this.$message.error('请检查是否有漏填项目!')
			}
		},
		async saveHandle () { // 保存（注意：点击保存时不用保存上传的文件）
			this.setSpinning(true)
			let familyMember = null
			const { form: { validateFields } } = this
      validateFields((errors, values) => {
        if (!errors) {
					familyMember = []
					values.name.map((item, index) => {
						familyMember.push({
							name: item,
							work: values.work[index]
						})
					})
        }
      })
			if (this.REAL_NAME || this.GRADE_ID || this.CLASS_ID || this.NATIVE_PLACE || this.REGISTE || this.STUDENT_ID_CARD || this.ADDRESS
			|| this.FAMILY_FORM || this.FAMILY_INCOME || this.FAMILY_MEDICAL_HISTORY || familyMember
			|| this.IS_MAIN_LIST || this.ACCEPT_CONSULT || this.ACCEPT_DIAGNOSIS || this.ACCEPT_MEDICAL || (this.STRESS_EVENT && this.STRESS_EVENT.length) || (this.NEGATIVE_CARRIER && this.NEGATIVE_CARRIER.length)
			|| this.THINK_DIRECTION || this.DEVELOP_TARGET || this.MANAGE_POWER || (this.CHARACTER_POINT && this.CHARACTER_POINT.length) || this.FRIEND_NUM || this.SLEEP_SITUATION || (this.PARENT_CHILD_RELATIONSHIP && this.PARENT_CHILD_RELATIONSHIP.length) || this.ACADEMIC_LEVEL
			|| this.IS_SCHOOL_STATUS || this.CRISIS_TIME_ONE || this.CRISIS_TIME_TWO || this.CRISIS_ADDRESS || this.CRISIS_ADDRESS_INPUT || this.CRISIS_WAY || (this.CRISIS_REASON && this.CRISIS_REASON.length) || this.CRISIS_SUPPLY || this.CURRENTLY_STATUS
			|| this.CONTACT_NAME || this.CONTACT_PHONE || this.CONTACT_EMAIL) {
				this.submitData(1, familyMember, '保存')
			} else {
				this.setSpinning(false)
				this.$message.error('没有可保存的信息!')
			}
		},
		cancel () { // 提交里面的取消
			console.log('取消提交')
		},
		cancelHandle () { // 外面的取消
			this.$router.push('/dataCenter/crisisEventEscalationRecord')
		},
		// 学生基本信息
		handleChangeGrade (value) { // 年级
			this.GRADE_ID = value
		},
		// 家庭基础信息
		handleChangeFAMILYFORM (value) { // 家庭结构
			this.FAMILY_FORM = value
			if (this.FAMILY_FORM === '其他') {
				this.FAMILY_FORM_INPUT_FLAG = true
			} else {
				this.FAMILY_FORM_INPUT_FLAG = false
			}
		},
		handleChangeFAMILYINCOME (value) { // 家庭收入水平
			this.FAMILY_INCOME = value
		},
		handleChangeFAMILYMEDICALHISTORY (value) { // 家庭精神病史
			this.FAMILY_MEDICAL_HISTORY = value
			if (this.FAMILY_MEDICAL_HISTORY === '有（何人何病）') {
				this.FAMILY_MEDICAL_HISTORY_INPUT_FLAG = true
			} else {
				this.FAMILY_MEDICAL_HISTORY_INPUT_FLAG = false
			}
		},
		// 危机发生前的状态
		handleChangeISMAIN (value) { // 列入重点关爱学生名单
			this.IS_MAIN_LIST = value.target.value
		},
		handleChangeCARELEVEL (value) { // 关爱等级
			this.CARE_LEVEL = value.target.value
		},
		handleChangeACCEPTCONSULT (value) { // 接受过心理咨询
			this.ACCEPT_CONSULT = value.target.value
		},
		handleChangeACCEPTDIAGNOSIS (value) {
			this.ACCEPT_DIAGNOSIS = value.target.value
		},
		handleChangeACCEPTMEDICAL (value) {
			this.ACCEPT_MEDICAL = value.target.value
		},
		handleChangeSTOPDRUG (value) {
			this.STOP_DRUG = value.target.value
		},
		handleChangefiles ({ fileList }) {
			if (fileList && fileList.length > 5) {
				this.fileList = fileList.slice(0, 5)
				this.$message.error('上传的文件数量已超出限制!')
				return false
			} else {
				this.fileList = fileList
			}
			console.log(fileList)
    },
		beforeUploadfile () {
			return false
		},
		// 危机发生前对该生的观察
		handleChangeTHINKDIRECTION (value) { // 思维倾向
			this.THINK_DIRECTION = value.target.value
		},
		handleChangeDEVELOPTARGET (value) { // 发展目标
			this.DEVELOP_TARGET = value.target.value
		},
		handleChangeMANAGEPOWER (value) { // 情绪管理控制力
			this.MANAGE_POWER = value.target.value
		},
		handleChangeFRIENDNUM (value) { // 朋友数量
			this.FRIEND_NUM = value.target.value
		},
		handleChangeSLEEPSITUATION (value) { // 睡眠情况
			this.SLEEP_SITUATION = value.target.value
		},
		handleChangeACADEMICLEVEL (value) { // 学业水平
			this.ACADEMIC_LEVEL = value.target.value
		},
		// 危机发生时的情况
		handleChangeISSCHOOLSTATUS (value) { // 是否停学休学
			this.IS_SCHOOL_STATUS = value.target.value
		},
		handleChangeCRISISTIMEONE (value) { // 日期
			this.CRISIS_TIME_ONE = value ? value.format('YYYY-MM-DD') : undefined
		},
		handleChangeCRISISTIMETWO (time) { // 时间
			this.CRISIS_TIME_TWO = time ? time.format('HH:mm:ss') : undefined
		},
		handleChangeCRISISADDRESS (value) { // 地点
			this.CRISIS_ADDRESS = value.target.value
		},
		handleChangeCRISISWAY (value) { // 方式
			this.CRISIS_WAY = value.target.value
		},
		handleChangefilesOther ({ fileList }) {
			if (fileList && fileList.length > 5) {
				this.fileListOther = fileList.slice(0, 5)
				this.$message.error('上传的文件数量已超出限制!')
				return false
			} else {
				this.fileListOther = fileList
			}
    },
		beforeUploadfileOther () {
			return false
		},
		interceptData (value, name, inputV) { // 根据&&&拆分选项和填空
			if (Array.isArray(value)) {
				let newArr = []
				// 数组-多选题
				value.map(item => {
					if (item.indexOf('&&&') !== -1) {
						let other = item.split('&&&')
						newArr.push(other[0])
						if (other[0] === inputV) {
							switch (name) {
								case '学校采取的干预措施':
									this.TAKE_MEASURES_INPUT = other[1]
									break
								case '危机前一周内发生的应激事件':
									this.STRESS_EVENT_INPUT = other[1]
									break
								case '危机前出现负面情绪的载体有':
									this.NEGATIVE_CARRIER_INPUT = other[1]
									break
								case '危机发生的主要原因':
									this.CRISIS_REASON_INPUT = other[1]
									break
								case '该生目前状态':
									this.CURRENTLY_STATUS_INPUT = other[1]
									break
							}
						}
					} else {
						newArr.push(item)
					}
				})
				return newArr
			} else {
				// 字符串-单选题、选择题
				let arr = value.split('&&&')
				if (arr[0] === inputV) {
					switch (name) {
						case '家庭结构':
							this.FAMILY_FORM_INPUT = arr[1]
							this.FAMILY_FORM_INPUT_FLAG = true
							break
						case '家庭精神病史':
							this.FAMILY_MEDICAL_HISTORY_INPUT = arr[1]
							this.FAMILY_MEDICAL_HISTORY_INPUT_FLAG = true
							break
						case '有无在本校心理中心/校外心理机构接受过心理咨询':
							this.ACCEPT_CONSULT_INPUT = arr[1]
							break
						case '危机前有无在专业医疗机构接受过医学诊断':
							this.ACCEPT_DIAGNOSIS_INPUT = arr[1]
							break
						case '危机发生时是否处于休学或停学状态':
							this.IS_SCHOOL_STATUS_INPUT = arr[1]
							break
						case '危机发生方式':
							this.CRISIS_WAY_INPUT = arr[1]
							break
					}
				}
				if (!inputV) { // 危机发生地点
					this.CRISIS_ADDRESS_INPUT = arr[1]
				}
				return arr[0]
			}
		},
		defaultValue () { // 显示最新的保存的信息
			if (this.crisisReferSaveInfo) {
				console.log(this.crisisReferSaveInfo, '保存的信息')
				// 学生基本信息
				this.REAL_NAME = this.crisisReferSaveInfo.REAL_NAME ? this.crisisReferSaveInfo.REAL_NAME : null
				this.GRADE_ID = this.crisisReferSaveInfo.GRADE_ID ? GRADE.gradeNameTwo(this.crisisReferSaveInfo.GRADE_ID) : undefined
				this.CLASS_ID = this.crisisReferSaveInfo.CLASS_ID ? this.crisisReferSaveInfo.CLASS_ID : null
				this.NATIVE_PLACE = this.crisisReferSaveInfo.NATIVE_PLACE ? this.crisisReferSaveInfo.NATIVE_PLACE : null
				this.REGISTE = this.crisisReferSaveInfo.REGISTE ? this.crisisReferSaveInfo.REGISTE : null
				this.STUDENT_ID_CARD = this.crisisReferSaveInfo.STUDENT_ID_CARD ? this.crisisReferSaveInfo.STUDENT_ID_CARD : null
				this.ADDRESS = this.crisisReferSaveInfo.ADDRESS ? this.crisisReferSaveInfo.ADDRESS : null
				// 家庭基础信息
				this.FAMILY_FORM = this.crisisReferSaveInfo.FAMILY_FORM ? this.interceptData(this.crisisReferSaveInfo.FAMILY_FORM, '家庭结构', '其他') : undefined
				this.FAMILY_INCOME = this.crisisReferSaveInfo.FAMILY_INCOME ? this.crisisReferSaveInfo.FAMILY_INCOME : undefined
				this.FAMILY_MEDICAL_HISTORY = this.crisisReferSaveInfo.FAMILY_MEDICAL_HISTORY ? this.interceptData(this.crisisReferSaveInfo.FAMILY_MEDICAL_HISTORY, '家庭精神病史', '有（何人何病）') : undefined
				this.FAMILY_MEMBERS_INFO = this.crisisReferSaveInfo.FAMILY_MEMBERS_INFO ? JSON.parse(this.crisisReferSaveInfo.FAMILY_MEMBERS_INFO) : [{ name: '', work: null }]
				// 危机发生前的状态
				this.IS_MAIN_LIST = this.crisisReferSaveInfo.IS_MAIN_LIST ? this.crisisReferSaveInfo.IS_MAIN_LIST : null
				this.CARE_LEVEL = this.crisisReferSaveInfo.CARE_LEVEL ? this.crisisReferSaveInfo.CARE_LEVEL : null
				this.TAKE_MEASURES = this.crisisReferSaveInfo.TAKE_MEASURES ? this.interceptData(this.crisisReferSaveInfo.TAKE_MEASURES.split(','), '学校采取的干预措施', '其他') : null
				this.ACCEPT_CONSULT = this.crisisReferSaveInfo.ACCEPT_CONSULT ? this.interceptData(this.crisisReferSaveInfo.ACCEPT_CONSULT, '有无在本校心理中心/校外心理机构接受过心理咨询', '校外咨询（请注明求助原因）') : null
				this.ACCEPT_DIAGNOSIS = this.crisisReferSaveInfo.ACCEPT_DIAGNOSIS ? this.interceptData(this.crisisReferSaveInfo.ACCEPT_DIAGNOSIS, '危机前有无在专业医疗机构接受过医学诊断', '去过医疗机构，诊断结果为：') : null
				this.ACCEPT_MEDICAL = this.crisisReferSaveInfo.ACCEPT_MEDICAL ? this.crisisReferSaveInfo.ACCEPT_MEDICAL : null
				this.STOP_DRUG = this.crisisReferSaveInfo.STOP_DRUG ? this.crisisReferSaveInfo.STOP_DRUG : null
				this.STRESS_EVENT = this.crisisReferSaveInfo.STRESS_EVENT ? this.interceptData(this.crisisReferSaveInfo.STRESS_EVENT.split(','), '危机前一周内发生的应激事件', '其他') : null
				this.NEGATIVE_CARRIER = this.crisisReferSaveInfo.NEGATIVE_CARRIER ? this.interceptData(this.crisisReferSaveInfo.NEGATIVE_CARRIER.split(','), '危机前出现负面情绪的载体有', '其他') : null
				this.fileList = null
				// 危机发生前对该生的观察
				this.THINK_DIRECTION = this.crisisReferSaveInfo.THINK_DIRECTION ? this.crisisReferSaveInfo.THINK_DIRECTION : null
				this.DEVELOP_TARGET = this.crisisReferSaveInfo.DEVELOP_TARGET ? this.crisisReferSaveInfo.DEVELOP_TARGET : null
				this.MANAGE_POWER = this.crisisReferSaveInfo.MANAGE_POWER ? this.crisisReferSaveInfo.MANAGE_POWER : null
				this.CHARACTER_POINT = this.crisisReferSaveInfo.CHARACTER_POINT ? this.crisisReferSaveInfo.CHARACTER_POINT.split(',') : null
				this.FRIEND_NUM = this.crisisReferSaveInfo.FRIEND_NUM ? this.crisisReferSaveInfo.FRIEND_NUM : null
				this.SLEEP_SITUATION = this.crisisReferSaveInfo.SLEEP_SITUATION ? this.crisisReferSaveInfo.SLEEP_SITUATION : null
				this.PARENT_CHILD_RELATIONSHIP = this.crisisReferSaveInfo.PARENT_CHILD_RELATIONSHIP ? this.crisisReferSaveInfo.PARENT_CHILD_RELATIONSHIP.split(',') : null
				this.ACADEMIC_LEVEL = this.crisisReferSaveInfo.ACADEMIC_LEVEL ? this.crisisReferSaveInfo.ACADEMIC_LEVEL : null
				// 危机发生时的情况
				this.IS_SCHOOL_STATUS = this.crisisReferSaveInfo.IS_SCHOOL_STATUS ? this.interceptData(this.crisisReferSaveInfo.IS_SCHOOL_STATUS, '危机发生时是否处于休学或停学状态', '是') : null
				this.CRISIS_TIME_ONE = this.crisisReferSaveInfo.CRISIS_TIME ? (this.crisisReferSaveInfo.CRISIS_TIME.split('&&&')[0] === 'undefined' ? undefined : this.crisisReferSaveInfo.CRISIS_TIME.split('&&&')[0]) : undefined
				this.CRISIS_TIME_TWO = this.crisisReferSaveInfo.CRISIS_TIME ? (this.crisisReferSaveInfo.CRISIS_TIME.split('&&&')[1] === 'undefined' ? undefined : this.crisisReferSaveInfo.CRISIS_TIME.split('&&&')[1]) : undefined
				this.CRISIS_ADDRESS = this.crisisReferSaveInfo.CRISIS_ADDRESS ? this.interceptData(this.crisisReferSaveInfo.CRISIS_ADDRESS, '危机发生地点', null) :  null
				this.CRISIS_WAY = this.crisisReferSaveInfo.CRISIS_WAY ? this.interceptData(this.crisisReferSaveInfo.CRISIS_WAY, '危机发生方式', '其他') :  null
				this.CRISIS_REASON =  this.crisisReferSaveInfo.CRISIS_REASON ? this.interceptData(this.crisisReferSaveInfo.CRISIS_REASON.split(','), '危机发生的主要原因', '其他') : null
				this.CRISIS_SUPPLY = this.crisisReferSaveInfo.CRISIS_SUPPLY ? this.crisisReferSaveInfo.CRISIS_SUPPLY : null
				this.fileListOther = null
				this.CURRENTLY_STATUS = this.crisisReferSaveInfo.CURRENTLY_STATUS ? this.interceptData(this.crisisReferSaveInfo.CURRENTLY_STATUS.split(','), '该生目前状态', '其他') : null
				// 学校联系人
				this.CONTACT_NAME = this.crisisReferSaveInfo.CONTACT_NAME ? this.crisisReferSaveInfo.CONTACT_NAME : null
				this.CONTACT_PHONE = this.crisisReferSaveInfo.CONTACT_PHONE ? this.crisisReferSaveInfo.CONTACT_PHONE : null
				this.CONTACT_EMAIL = this.crisisReferSaveInfo.CONTACT_EMAIL ? this.crisisReferSaveInfo.CONTACT_EMAIL : null
			}
		}
	},
	watch: {
		crisisReferSaveInfo () {
			this.defaultValue()
		}
	},
	mounted () {
		this.defaultValue()
	}
}
</script>

<style scoped>
.tags {
	white-space:nowrap;
	margin-right: 10px;
}
#crisisEventEscalationDetails {
	padding-bottom: 60px;
}
#crisisEventEscalationDetails h2 {
	font-size: 14px;
	font-weight: bold;
}
#crisisEventEscalationDetails > div {
	background: #FFFFFF;
	border-radius: 2px;
	margin-top: 20px;
}
#crisisEventEscalationDetails .describe {
	padding: 16px 24px;
	box-sizing: border-box;
}
#crisisEventEscalationDetails .describe span {
	color: rgba(250, 10, 10, 0.85);
}
#crisisEventEscalationDetails .title {
	border-bottom: 1px solid #E8E8E8;
	padding: 16px 24px;
	box-sizing: border-box;
	color: #333333;
	font-weight: bold;
}
#crisisEventEscalationDetails .content {
	padding: 16px 24px;
	box-sizing: border-box;
}
#crisisEventEscalationDetails .endof {
	display: flex;
	justify-content: flex-end;
	border-top: 1px solid #E8E8E8;
	padding: 16px 24px;
	box-sizing: border-box;
}
#crisisEventEscalationDetails .endof .ant-btn {
	margin-left: 8px;
}
#crisisEventEscalationDetails .endof .trebtn {
	background: transparent!important;
	color: rgba(0, 0, 0, 0.65)!important;
	border-color: #D9D9D9!important;
}
#crisisEventEscalationDetails .endof .trebtn:hover {
	border-color: #51BF94!important;
	color: #51BF94!important;
}
#crisisEventEscalationDetails .content .ant-input {
	width: 200px!important;
}
#crisisEventEscalationDetails .content .ant-input-affix-wrapper {
	width: 100px;
}
#crisisEventEscalationDetails .content .ant-select {
	margin-right: 8px;
}
#crisisEventEscalationDetails .content .ant-checkbox-group {
	width: 100%;
	/* display: flex; */
	/* flex-direction: column; */
	/* white-space:nowrap; */
}
#crisisEventEscalationDetails .content .ant-checkbox-group >>> .ant-checkbox-group-item {
	min-width: 150px;
	word-wrap: break-word;
    word-break: normal;
	margin-bottom: 8px;
}
#crisisEventEscalationDetails .content > div {
	margin-top: 20px;
	margin-bottom: 20px;
}
#crisisEventEscalationDetails .content .row {
	display: flex;
	align-items: center;
}
#crisisEventEscalationDetails .content .flexStart {
	align-items: flex-start;
}
#crisisEventEscalationDetails .content .flexStart > b {
	display: inline-block;
	padding-top: 8px;
	font-weight: normal;
}
#crisisEventEscalationDetails .content .flexStart p {
	margin-top: 20px;
	margin-bottom: 0px;
}
#crisisEventEscalationDetails .content .column {
	display: flex;
	flex-direction: column;
	justify-content: center;
}
#crisisEventEscalationDetails .content .column .ant-input {
	margin-top: 8px;
}
#crisisEventEscalationDetails .content .row .warning, #crisisEventEscalationDetails .content .column .warning {
	color: rgba(250, 10, 10, 0.85);
	display: flex;
	align-items: center;
}
#crisisEventEscalationDetails .content .row .warning .anticon-info-circle, #crisisEventEscalationDetails .content .column .warning .anticon-info-circle {
	margin-right: 4px;
}
#crisisEventEscalationDetails .content .row > .warning {
	margin-left: 10px;
}
#crisisEventEscalationDetails .content .column .warning, #crisisEventEscalationDetails .content .shrink > div .warning {
	margin-top: 8px;
}
</style>
